import {IBaseLookup} from "./Ibase.lookup";

export namespace Icon {

	export const lookupName: string = "Icon";

	export interface Icon{
		iconKey: number;
		icon: string;
		type: number;
		active: string;
		description: string;
		last_updated: Date;
		name: string;

	}

	export interface IconDS extends IBaseLookup {
		icon: Icon[];
	}
}
